if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        if (
          typeof window.isExclusiveMainVariantId === 'function' &&
          window.isExclusiveMainVariantId(variantId)
        ) {
          // 读取 PDP 上被勾选的赠品 benefit
          const $scope = $(this.form).closest('.shokz-main-product-content-wrapper');
          $scope.find('.benefit-wrapper.buy-x-get-y:not(.hidden)').each(function () {
            if ($(this).find('.product-wrapper.active').length > 0) {
              const giftVariantId = $(this).data('id');
              if (giftVariantId) {
                formData.append(`properties[_G_${giftVariantId}]`, '1');
              }
            }
          });
          // 在 PDP 上添加的主产品始终打上标记
          formData.append('properties[_G_FromPdp]', '1');
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, flag = 0) {
        let discontinued_id = this.submitButton.getAttribute('discontinued-id')
        let variant_id = new URLSearchParams(window.location.search).get('variant')
        if (disable) {
         
          if (flag == 1) {
            this.submitButton.setAttribute('data-disabled', 1);
          }
          this.submitButton.setAttribute('disabled', 'disabled');
          // 判断产品是否是停产状态
          if (discontinued_id.indexOf(variant_id) != -1 || this.querySelector('.product-variant-id').value.length == 0) {
            this.submitButtonText.textContent = 'Discontinued'
          } else if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.setAttribute('data-disabled', 0);
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;

          // if (location.pathname == '/products/opendots-one' && this.submitButton.getAttribute('data-pre-id').indexOf(new URLSearchParams(window.location.search).get('variant')) > -1) {
          //   this.submitButtonText.textContent = 'Pre-order';
          //   this.querySelector('.pre_order_tip')?.classList.remove('hidden')
          //   $('.product-form__buttons .product-form__submit').attr('data-capitalize', '')
          // }
          // else {
          //   this.querySelector('.pre_order_tip')?.classList.add('hidden')
          //   this.submitButton.removeAttribute('data-capitalize')
          //   $('.product-form__buttons .product-form__submit').removeAttr('data-capitalize')
          // }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}